/* =============================================
   Fran:Contexto_Auto_Vídeos — JS
   Asset: vshop-context.js
   ============================================= */
(function(){
  document.querySelectorAll('.vshop[data-section-id]').forEach(function(root){

    var track=root.querySelector('.vshop__track');
    var cards=[].slice.call(root.querySelectorAll('.vshop__media'));
    var modal=root.querySelector('.vshop__modal');
    var player=root.querySelector('.vshop__player');
    var prev=root.querySelector('.vshop__nav--prev');
    var next=root.querySelector('.vshop__nav--next');
    var prevTrack=root.querySelector('.vshop__arrow--prev');
    var nextTrack=root.querySelector('.vshop__arrow--next');
    var pill=root.querySelector('.vshop__float-shop');
    var pillCount=root.querySelector('.vshop__float-shop span');
    var panel=root.querySelector('.vshop__float-panel');
    var panelContent=root.querySelector('.vshop__float-content');
    var panelClose=root.querySelector('.vshop__float-close');
    var active=0,startX=0,startY=0;

    function parseJson(str){
      try{return JSON.parse(str||'[]')}
      catch(e){return[]}
    }

    function clearPlayer(){
      if(player)player.innerHTML='';
    }

    function lockScroll(lock){
      document.documentElement.style.overflow=lock?'hidden':'';
      document.body.style.overflow=lock?'hidden':'';
    }

    function renderPlayer(card){
      clearPlayer();

      var type=card.dataset.videoType;
      var source=card.dataset.videoSource;
      var embed=card.dataset.embedUrl;

      if(type==='youtube'&&embed){
        var iframe=document.createElement('iframe');
        iframe.src=embed;
        iframe.loading='eager';
        iframe.frameBorder='0';
        iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen=true;
        player.appendChild(iframe);
        return;
      }

      if(type==='tiktok'&&embed){
        var tik=document.createElement('iframe');
        tik.src=embed;
        tik.loading='eager';
        tik.frameBorder='0';
        tik.scrolling='no';
        tik.allow='autoplay; encrypted-media; picture-in-picture';
        tik.allowFullscreen=true;
        player.appendChild(tik);
        return;
      }

      if(type==='instagram'&&embed){
        var ig=document.createElement('iframe');
        ig.src=embed;
        ig.loading='eager';
        ig.frameBorder='0';
        ig.scrolling='no';
        ig.allow='autoplay; encrypted-media; picture-in-picture';
        ig.allowFullscreen=true;
        player.appendChild(ig);
        return;
      }

      if(source){
        var video=document.createElement('video');
        video.src=source;
        video.controls=true;
        video.autoplay=true;
        video.playsInline=true;
        video.preload='none';
        player.appendChild(video);
        video.play().catch(function(){});
      }
    }

    function itemHtml(item,type){
      var title=item.title||'';
      var url=item.url||'#';
      var img=item.image?'<img src="'+item.image+'" alt="">':'<span class="vshop__float-empty"></span>';
      var meta=type==='product'?((item.vendor?item.vendor+' · ':'')+(item.price||'')):'Colección';
      var cta=type==='product'?'Ver':'Abrir';

return '<a class="vshop__float-item" href="'+url+'" target="_blank" rel="noopener">'+
        img+
        '<span><span class="vshop__float-name">'+title+'</span><span class="vshop__float-meta">'+meta+'</span></span>'+
        '<span class="vshop__float-cta">'+cta+'</span>'+
      '</a>';
    }

    function renderShop(card){
      var products=parseJson(card.dataset.products);
      var collections=parseJson(card.dataset.collections);
      var total=products.length+collections.length;

      panel.hidden=true;
      panelContent.innerHTML='';

      if(!total){
        pill.hidden=true;
        return;
      }

      pill.hidden=false;
      pillCount.textContent=total;

      var html='';

      if(products.length){
        html+='<div class="vshop__float-title">Productos</div>';
        products.forEach(function(p){html+=itemHtml(p,'product')});
      }

      if(collections.length){
        html+='<div class="vshop__float-title">Colecciones</div>';
        collections.forEach(function(c){html+=itemHtml(c,'collection')});
      }

      panelContent.innerHTML=html;
    }

    function openModal(index){
      if(!cards.length)return;

      active=index;
      if(active<0)active=cards.length-1;
      if(active>=cards.length)active=0;

      modal.hidden=false;
      lockScroll(true);
      renderPlayer(cards[active]);
      renderShop(cards[active]);
    }

    function closeModal(){
      modal.hidden=true;
      clearPlayer();
      if(panel)panel.hidden=true;
      if(pill)pill.hidden=true;
      lockScroll(false);
    }

    function go(dir){
      openModal(active+dir);
    }

    cards.forEach(function(card,i){
      card.addEventListener('click',function(){
        openModal(i);
      });
    });

    root.querySelectorAll('[data-close]').forEach(function(el){
      el.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    });

    if(prev)prev.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    });

    if(next)next.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      go(1);
    });

    if(prevTrack&&track)prevTrack.addEventListener('click',function(){
      track.scrollBy({left:-track.clientWidth*.85,behavior:'smooth'});
    });

    if(nextTrack&&track)nextTrack.addEventListener('click',function(){
      track.scrollBy({left:track.clientWidth*.85,behavior:'smooth'});
    });

    if(pill)pill.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      pill.hidden=true;
      panel.hidden=false;
    });

    if(panelClose)panelClose.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      panel.hidden=true;
      pill.hidden=false;
    });

    modal.addEventListener('touchstart',function(e){
      if(!e.touches.length)return;
      startX=e.touches[0].clientX;
      startY=e.touches[0].clientY;
    },{passive:true});

    modal.addEventListener('touchend',function(e){
      if(modal.hidden)return;
      if(!e.changedTouches.length)return;

      var target=e.target;
      if(target.closest && target.closest('iframe, video, .vshop__float-panel, .vshop__float-shop, .vshop__close, .vshop__nav'))return;

      var dx=e.changedTouches[0].clientX-startX;
      var dy=e.changedTouches[0].clientY-startY;

      if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)){
        dx<0?go(1):go(-1);
      }
    },{passive:true});

    document.addEventListener('keydown',function(e){
      if(modal.hidden)return;
      if(e.key==='Escape')closeModal();
      if(e.key==='ArrowRight')go(1);
      if(e.key==='ArrowLeft')go(-1);
    });

  });
})();
